import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { ExecutionService } from './execution.service';
import { ExecutionResolver } from './execution.resolver';
import { ExecutionEditComponent } from './execution-edit.component';
import { ExecutionForDossierComponent } from './execution-for-dossier.component';
import { ExecutionForOperationComponent } from './execution-for-operation.component';
import { SelectTreeComponent } from './select-tree.component';
import { SelectTreeItemComponent } from './select-tree-item.component';
import { SelectOperationComponent } from './select-operation.component';
import { SelectRevisionComponent } from './select-revision.component';
import { SelectDossierComponent } from './select-dossier.component';
import { SelectRootFieldsComponent } from './select-root-fields.component';
import { DownloadTreeComponent } from './download-tree.component';
import { ExecutionFormComponent } from './execution-form.component';
import { DownloadDialogComponent } from './download-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    ExecutionEditComponent,
    ExecutionForDossierComponent,
    ExecutionForOperationComponent,
    SelectTreeComponent,
    SelectTreeItemComponent,
    SelectOperationComponent,
    SelectRevisionComponent,
    SelectDossierComponent,
    SelectRootFieldsComponent,
    DownloadTreeComponent,
    ExecutionFormComponent,
    DownloadDialogComponent
  ],
  providers: [
    ExecutionService,
    ExecutionResolver
  ],
  bootstrap: [
    DownloadDialogComponent,
  ]
})
export class ExecutionModule { }
